export const swapKV = <K extends PropertyKey, V extends PropertyKey>(obj: Record<K, V>): Record<V, K> => {
  return Object.fromEntries(Object.entries(obj).map(([k, v]) => [v, k])) as Record<V, K>;
};
